// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Add, Update, Delete.
// MODIFIED DATE : 14-08-2025

import { call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	// Add Group Account Details Response
	addGroupAccountDetailsFailure,
	addGroupAccountDetailsResponseChanged,
	addGroupAccountDetailsSuccess,
	// All Group Account Export Response
	allGroupAccountExportFailure,
	allGroupAccountExportResponseChanged,
	allGroupAccountExportSuccess,
	// Delete Group Account Details Resposne
	deleteGroupAccountDetailsFailure,
	deleteGroupAccountDetailsResponseChanged,
	deleteGroupAccountDetailsSuccess,
	// Fetch Group Account Details Resposne
	fetchGroupAccountDetailsFailure,
	fetchGroupAccountDetailsResponseChanged,
	fetchGroupAccountDetailsSuccess,
	// Get Group Account List Response
	getGroupAccountListFailure,
	getGroupAccountListResponseChanged,
	getGroupAccountListSuccess,
	// Get Primary Account List Resposne
	getPrimaryAccountListFailure,
	getPrimaryAccountListResponseChanged,
	getPrimaryAccountListSuccess,
	// Update Group Account Details Response
	updateGroupAccountDetailsFailure,
	updateGroupAccountDetailsResponseChanged,
	updateGroupAccountDetailsSuccess,
} from './groupAccount.action';
import GroupAccountActionTypes from './groupAccount.types';
import { all } from 'redux-saga/effects';
import {
	AllGroupAccountExportService,
	GroupAccountCreate,
	GroupAccountDelete,
	GroupAccountListGet,
	GroupAccountUpdate,
	ParticularGroupDetailsFetch,
	PrimaryAccountListGet,
} from './groupAccount.service';

/** ***************** ADD GROUP ACCOUNT DETAILS START *********************** */
export function* addGroupAccountDetails({ payload }: any) {
	try {
		const key = 'CreateGroupAccountListKey';
		const {
			infogCompanyID,
			userID,
			groupAccountName,
			groupAccountCode,
			primaryAccount,
			userName,
			partyStatus,
			bankStatus,
			cashStatus,
			groupReportChronology,
			incomeExpenditureStatus,
			trailBalanceReportStatus,
			balanceSheetReportStatus,
			carryForwordStatus,
			databaseName,
		} = payload;

		const jsonData = {
			InfogID: infogCompanyID,
			UserID: userID,
			GroupAccountName: groupAccountName,
			GroupAccountCode: groupAccountCode,
			PrimaryAccountID: primaryAccount,
			GroupReportChronology: groupReportChronology,
			UserName: userName,
			PartyStatus: partyStatus,
			BankStatus: bankStatus,
			CashStatus: cashStatus,
			IE_ReportStatus: incomeExpenditureStatus,
			TB_ReportStatus: trailBalanceReportStatus,
			BS_ReportStatus: balanceSheetReportStatus,
			CarryForward: carryForwordStatus,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(GroupAccountCreate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addGroupAccountDetailsFailure(responseData.data));
		} else {
			yield put(addGroupAccountDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addGroupAccountDetailsFailure(error));
	}
}

export function* resetAddGroupAccountDetailsResponse() {
	yield put(addGroupAccountDetailsResponseChanged());
}

export function* onAddGroupAccountDetails() {
	yield takeLatest(
		GroupAccountActionTypes.ADD_GROUP_ACCOUNT_DETAILS_START,
		addGroupAccountDetails,
	);
}

export function* onAddGroupAccountDetailsResponseReset() {
	yield takeLatest(
		GroupAccountActionTypes.ADD_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
		resetAddGroupAccountDetailsResponse,
	);
}
/** ***************** ADD GROUP ACCOUNT DETAILS END *********************** */

/** ***************** UPDATE GROUP ACCOUNT DETAILS START *********************** */
export function* updateGroupAccountDetails({ payload }: any) {
	try {
		const key = 'UpdateGroupAccountListKey';
		const {
			infogCompanyID,
			userID,
			groupAccountID,
			groupAccountName,
			groupAccountCode,
			primaryAccount,
			groupReportChronology,
			userName,
			partyStatus,
			bankStatus,
			cashStatus,
			incomeExpenditureStatus,
			trailBalanceReportStatus,
			balanceSheetReportStatus,
			carryForwordStatus,
			databaseName,
		} = payload;

		const jsonData = {
			InfogID: infogCompanyID,
			UserID: userID,
			GroupAccountID: groupAccountID,
			GroupAccountName: groupAccountName,
			GroupAccountCode: groupAccountCode,
			PrimaryAccountID: primaryAccount,
			GroupReportChronology: groupReportChronology,
			UserName: userName,
			PartyStatus: partyStatus,
			BankStatus: bankStatus,
			CashStatus: cashStatus,
			IE_ReportStatus: incomeExpenditureStatus,
			TB_ReportStatus: trailBalanceReportStatus,
			BS_ReportStatus: balanceSheetReportStatus,
			CarryForward: carryForwordStatus,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(GroupAccountUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateGroupAccountDetailsFailure(responseData.data));
		} else {
			yield put(updateGroupAccountDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateGroupAccountDetailsFailure(error));
	}
}

export function* resetUpdateGroupAccountDetailsResponse() {
	yield put(updateGroupAccountDetailsResponseChanged());
}

export function* onUpdateGroupAccountDetails() {
	yield takeLatest(
		GroupAccountActionTypes.UPDATE_GROUP_ACCOUNT_DETAILS_START,
		updateGroupAccountDetails,
	);
}

export function* onUpdateGroupAccountDetailsResponseReset() {
	yield takeLatest(
		GroupAccountActionTypes.UPDATE_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
		resetUpdateGroupAccountDetailsResponse,
	);
}
/** ***************** UPDATE GROUP ACCOUNT DETAILS END *********************** */

/** ***************** GET GROUP ACCOUNT LIST START *********************** */
export function* getGroupAccountList({ payload }: any) {
	try {
		const key = 'GetGroupAccountListKey';
		const { infogCompanyID, databaseName, limit, inputSearch } = payload;

		const jsonData = {
			InfogID: infogCompanyID,
			DatabaseName: databaseName,
			Limit: limit,
			InputSearch: inputSearch,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(GroupAccountListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGroupAccountListFailure(responseData.data));
		} else {
			yield put(getGroupAccountListSuccess(responseData.data));
		}
	} catch (error) {
		console.log('error', error);
		yield put(getGroupAccountListFailure(error));
	}
}

export function* resetGetGroupAccountListResponse() {
	yield put(getGroupAccountListResponseChanged());
}

export function* onGetGroupAccountList() {
	yield takeLatest(GroupAccountActionTypes.GET_GROUP_ACCOUNT_LIST_START, getGroupAccountList);
}

export function* onGetGroupAcountListResponseReset() {
	yield takeLatest(
		GroupAccountActionTypes.GET_GROUP_ACCOUNT_LIST_RESPONSE_RESET,
		resetGetGroupAccountListResponse,
	);
}
/** ***************** GET GROUP ACCOUNT LIST END *********************** */

/** ***************** GET PRIMAY ACCOUNT LIST START *********************** */
export function* getPrimaryAccount({ payload }: any) {
	try {
		const key = 'GetPrimaryAccountListKey';
		const { infogCompanyID, databaseName } = payload;

		const jsonData = {
			InfogID: infogCompanyID,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(PrimaryAccountListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPrimaryAccountListFailure(responseData.data));
		} else {
			yield put(getPrimaryAccountListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPrimaryAccountListFailure(error));
	}
}

export function* resetGetPrimaryAccountListResponse() {
	yield put(getPrimaryAccountListResponseChanged());
}

export function* onGetPrimaryAccountList() {
	yield takeLatest(GroupAccountActionTypes.GET_PRIMARY_ACCOUNT_LIST_START, getPrimaryAccount);
}

export function* onGetPrimaryAccountListResponseReset() {
	yield takeLatest(
		GroupAccountActionTypes.GET_PRIMARY_ACCOUNT_LIST_RESPONSE_RESET,
		resetGetPrimaryAccountListResponse,
	);
}
/** ***************** GET PRIMARY ACCOUNT LIST END *********************** */

/** ***************** FETCH GROUP ACCOUNT DETAILS START *********************** */
export function* fetchGroupAccountDetails({ payload }: any) {
	try {
		const key = 'GetParticularAccountListKey';
		const { infogCompanyID, groupAccountID, databaseName } = payload;

		const jsonData = {
			InfogID: infogCompanyID,
			GroupAccountID: groupAccountID,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ParticularGroupDetailsFetch, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchGroupAccountDetailsFailure(responseData.data));
		} else {
			yield put(fetchGroupAccountDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchGroupAccountDetailsFailure(error));
	}
}

export function* resetFetchGroupAccountDetailsResponse() {
	yield put(fetchGroupAccountDetailsResponseChanged());
}

export function* onFetchGroupAccountDetails() {
	yield takeLatest(
		GroupAccountActionTypes.FETCH_GROUP_ACCOUNT_DETAILS_START,
		fetchGroupAccountDetails,
	);
}

export function* onFetchGroupAccountDetailsResponseReset() {
	yield takeLatest(
		GroupAccountActionTypes.FETCH_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
		resetFetchGroupAccountDetailsResponse,
	);
}
/** ***************** FETCH GROUP ACCOUNT DETAILS END *********************** */

/** ***************** DELETE GROUP ACCOUNT DETAILS START *********************** */
export function* deteleGroupAccountDetails({ payload }: any) {
	try {
		const key = 'DeleteGroupAccountListKey';
		const { infogCompanyID, groupAccountID, userID, userName, databaseName } = payload;

		const jsonData = {
			InfogID: infogCompanyID,
			GroupAccountID: groupAccountID,
			UserID: userID,
			UserName: userName,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(GroupAccountDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteGroupAccountDetailsFailure(responseData.data));
		} else {
			yield put(deleteGroupAccountDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteGroupAccountDetailsFailure(error));
	}
}

export function* resetDeleteGroupAccountDetailsResponse() {
	yield put(deleteGroupAccountDetailsResponseChanged());
}

export function* onDeleteGroupAccountDetails() {
	yield takeLatest(
		GroupAccountActionTypes.DELETE_GROUP_ACCOUNT_DETAILS_START,
		deteleGroupAccountDetails,
	);
}

export function* onDeleteGroupAccountDetailsResponseReset() {
	yield takeLatest(
		GroupAccountActionTypes.DELETE_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
		resetDeleteGroupAccountDetailsResponse,
	);
}
/** ***************** DELETE GROUP ACCOUNT DETAILS END *********************** */

/** ***************** ALL GROUP ACCOUNT EXPORT START *********************** */
export function* allGroupAccountExport({ payload }: any) {
	try {
		const key = 'AllGroupAccountExportKey';
		const { infogCompanyID, databaseName } = payload;

		const jsonData = {
			InfogID: infogCompanyID,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(AllGroupAccountExportService, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(allGroupAccountExportFailure(responseData.data));
		} else {
			yield put(allGroupAccountExportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(allGroupAccountExportFailure(error));
	}
}

export function* resetAllGroupAccountExportResponse() {
	yield put(allGroupAccountExportResponseChanged());
}

export function* onAllGroupAccountExportStart() {
	yield takeLatest(GroupAccountActionTypes.ALL_GROUP_ACCOUNT_EXPORT_START, allGroupAccountExport);
}

export function* onAllGroupAccountExportResponseReset() {
	yield takeLatest(
		GroupAccountActionTypes.ALL_GROUP_ACCOUNT_EXPORT_RESPONSE_RESET,
		resetAllGroupAccountExportResponse,
	);
}
/** ***************** ALL GROUP ACCOUNT EXPORT END *********************** */

export function* groupAccountFinanceSaga() {
	yield all([
		// Add Group Account Details Response
		call(onAddGroupAccountDetails),
		call(onAddGroupAccountDetailsResponseReset),
		// Get Group Account List Response
		call(onGetGroupAccountList),
		call(onGetGroupAcountListResponseReset),
		// Get Primary Account List Resposne
		call(onGetPrimaryAccountList),
		call(onGetPrimaryAccountListResponseReset),
		// Fetch Group Account Details Resposne
		call(onFetchGroupAccountDetails),
		call(onFetchGroupAccountDetailsResponseReset),
		// Update Group Account Details Response
		call(onUpdateGroupAccountDetails),
		call(onUpdateGroupAccountDetailsResponseReset),
		// Delete Group Account Details Resposne
		call(onDeleteGroupAccountDetails),
		call(onDeleteGroupAccountDetailsResponseReset),
		// All Group Account Export Response
		call(onAllGroupAccountExportStart),
		call(onAllGroupAccountExportResponseReset),
	]);
}
